











































import Vue, { PropType } from "vue";
import _raids from "@/services/endpoints/raids";
import { userRaid } from "models/Types";

export default Vue.extend({
	name: "LogUploadComp",
	props: {
		raid: Object as PropType<userRaid>,
		disabled: Boolean,
	},
	data: () => ({
		dialog: false,
		token: "",
		tokenSaved: false,
	}),
	methods: {
		generateToken: async function(): Promise<void> {
			const response = await _raids.generateUserToken(this.raid.id);
			if (response.success) {
				this.token = response.token;
				this.tokenSaved = true;
			}
		},
		save: async function(): Promise<void> {
			// call to the backend to set the token for the raid.
			if (!this.tokenSaved && this.token != null && this.token.trim() != null) {
				await _raids.setUserToken(this.raid.id, this.token);
			}
			this.dialog = false;
		},
		onChange(): void {
			if (this.tokenSaved) {
				this.tokenSaved = false;
			}
		},
	},
	created: async function(): Promise<void> {
		if (this.raid && this.raid.dpsReportToken) {
			// set the initial token equal to the one of the raid.
			this.token = this.raid.dpsReportToken;
			this.tokenSaved = true;
		}
	},
});
